export default "/images/vendor/flag-icon-css/flags/1x1/sa.svg?0ac9ef7170a22c1902900177ca1bfb2a";